export default (client) => {
  return {
    estado() {
      return client.get('/extras-mg/ayuda/')
    },
    preguntar(mensajes, pagina) {
      return client.post('/extras-mg/ayuda/chat/', { mensajes, pagina })
    },
    levantarTicket(formulario) {
      return client.post('/extras-mg/ayuda/ticket/', formulario, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    },
  }
}
